
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { ExportVisitorLogModule } from '../../components/reporting/export-visitor-log/export-visitor-log.module';
import { ExportVisitorLogWidgetComponent } from './components/export-visitor-log-widget.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModule,
    FormsModule,
    CommonTranslationModule,
    CommonLayoutModule,
    ExportVisitorLogModule
  ],
  declarations: [
    ExportVisitorLogWidgetComponent
  ],
  exports: [
    ExportVisitorLogWidgetComponent
  ]
})
export class ExportVisitorLogWidgetModule { }
